import { render, staticRenderFns } from "./addnew.vue?vue&type=template&id=783b845a&scoped=true&"
import script from "./addnew.vue?vue&type=script&lang=js&"
export * from "./addnew.vue?vue&type=script&lang=js&"
import style0 from "./addnew.vue?vue&type=style&index=0&id=783b845a&prod&lang=scss&"
import style1 from "./addnew.vue?vue&type=style&index=1&id=783b845a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783b845a",
  null
  
)

export default component.exports